<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>
        <div class="checkout-tabs">
            <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-lg-2 w-100">
                <b-tab v-for="(info, key, index) in data" :key="info.group.sgid" :active="index === 0">
                    <template v-slot:title>
                        <div class="py-3">{{ info.group.name }}</div>
                    </template>
                    
                    <div class="row mt-5">
                        <div class="col-md-4" v-for="client in info.clients" :key="client.info.dbid">
                            <div class="card">
                                <div class="card-header">
                                    <client-avatar :dbid="client.info.dbid" :size="100"/>
                                </div>
                                <div class="card-body">
                                    <h4><client :client="client.info" center/></h4>
                                </div>
                                <div class="card-footer">
                                    <admin-opinion
                                        :dbid="client.info.dbid"
                                        :add="client.opinions.add"
                                        :pos="count(client, true)"
                                        :neg="count(client, false)"
                                        v-on:added="loadData"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </div>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import AdminOpinionsService from "@/services/admin-opinions.service";
import ClientAvatar from "@/components/teamspeak/ClientAvatar";
import AdminOpinion from "@/components/AdminOpinion";

/**
 * Starter component
 */
export default {
    name: "Faq",
    components: {ClientAvatar, Layout, PageHeader, AdminOpinion},
    data() {
        return {
            title: "Oceń admina",
            items: [
                {
                    text: "Serwer",
                    href: "/"
                },
                {
                    text: "Oceń admina",
                    active: true
                }
            ],
            loading: true,
            data: null
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.loading = true;
            
            AdminOpinionsService.getAll().then(
                response => {
                    this.data = response.data;
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        count(client, positive) {
            let result = client.opinions.data.filter(o => o.positive == positive);
            return result.length;
        }
    }
};
</script>

<style scoped lang="scss">
.card-header {
    background-color: transparent;
    border: none;
    padding: 0;
    display: flex;
    justify-content: center;
    
    .avatar {
        width: 100px;
        height: 100px;
        border-radius: 50px;
        margin-top: -50px;
    }
}
</style>